@if(item()?.navCap){ @if(item()?.divider){ <span class="sidebar-divider"></span>}
  <div mat-subheader class="nav-caption">
    <span class="caption-text">{{ item()?.navCap | translate }}</span>
  </div>
} @if(!item()?.navCap && !item()?.external && !item()?.twoLines) {
  <a mat-list-item (click)="onItemSelected(item())" [ngClass]="{
    'mat-toolbar bg-light-primary text-primary active-menu': item()?.route
      ? router.isActive(item()?.route, true)
      : false,
    expanded: expanded,
    disabled: item()?.disabled
  }" class="menu-list-item {{ item()?.bgcolor }}" [attr.data-tour]="item()?.dataTour" (mouseenter)="onIconMouseEnter()" (mouseleave)="onIconMouseLeave()">
    @if(item()?.subItemIcon){
      <span matListItemIcon [ngStyle]="{'transform-origin': 'center'}"><app-icon
          [class.hovered]="iconHoverState === 'hovered'" class="nav-icon routeIcon sub-item-icon"
          [icon]="item()?.iconName ?? ''" customClass="routeIcon sub-item-icon"></app-icon></span>
    } @else {
      <span matListItemIcon [ngStyle]="{'transform-origin': 'center'}"><app-icon
          [class.hovered]="iconHoverState === 'hovered'" class="nav-icon routeIcon" [icon]="item()?.iconName ?? ''"
          customClass="routeIcon"></app-icon></span>
    }
    <span class="hide-menu">{{ item()?.displayName | translate }}</span>

    @if(item()?.disabled) {
      <span class="notification-icon">
        <mat-icon>notifications</mat-icon>
      </span>
    }

    @if(item()?.children && item()?.children.length) {
      <span class="arrow-icon" fxFlex>
        <span fxFlex></span>
        <mat-icon class="expand-icon" [class.expanded]="expanded">
          expand_more
        </mat-icon>
      </span>
    } @if(item()?.chip) {
      <span>
        <span class="{{ item()?.chipClass }} p-x-8 p-y-4 item-chip f-w-500 rounded-pill ">{{ item()?.chipContent | translate
      }}</span>
      </span>
    }
  </a>
}

<!-- external Link -->

@if(!item()?.navCap && item()?.external) {
  <mat-list-item onClick="window.open('//google.com')" class="menu-list-item {{ item()?.bgcolor }}" [attr.data-tour]="item()?.dataTour" target="_blank">
    <span matListItemIcon><app-icon [icon]="item()?.iconName ?? ''" customClass="routeIcon"></app-icon></span>
    <span class="hide-menu">{{ item()?.displayName | translate }}</span>
  </mat-list-item>
}

<!-- children -->
@if(expanded) {
  <div class="children-container" [attr.data-parent-depth]="depth()">
    @for(child of item()?.children; track child.route || child.displayName || $index) {
      <app-nav-item [item]="child" (click)="onSubItemSelected(child)" [depth]="depth() + 1">
      </app-nav-item>
    }
  </div>
}